export const LOCALIZE_FUNCTIONALITY = 'FUNCIONALIDADE LOCALIZE';
